<template>
    <form>
        <!-- Фильтр -->
        <div class="mb-4  w-full">
            <multiselect
                v-model="VisorData"
                class="w-full"
                :options="edvisors"
                :placeholder="$t('select_new_adviser')"
                 :selectedLabel="$t('selected')"
                @remove="multiselectRemove"
                @select="multiselectAction"
                @open="fetchStudyPlan"
                :loading="loading"
                v-validate="'required'"
                :custom-label="(obj) =>{var middleName = obj.middleName?obj.middleName+' ':'';return  obj.firstName+' '+obj.lastName+ ' ' + middleName }"
                name="discipline"
                track-by="profileId">
                    <template slot="singleLabel" slot-scope="props">{{ props.option.lastName}} {{ props.option.firstName}} {{ props.option.middleName}}</template>
                    <template slot="option" slot-scope="props">{{ props.option.lastName}} {{ props.option.firstName}} {{ props.option.middleName}}</template>
                    <div slot="noOptions">{{$t('no_data_text')}}</div>
            </multiselect>
            <span class="text-danger text-sm" v-show="errors.has('discipline')">{{ $t('validation_required') }}</span>
        </div>

        <div class="vx-col w-full">
            <vs-textarea class="mb-0" v-validate="'required'" name="description" :label="$t('reason_change_adviser')"
                v-model="description" />
            <span class="text-danger text-sm" v-show="errors.has('description')">{{ $t('validation_required') }}</span>
        </div>
<!--        <a @click="gdgdg()">dssdsd</a>-->
        <vs-button type="filled" @click="formSubmit" class="mt-4 block pay_btn w-full lg:w-auto">
            {{$t('send')}}
        </vs-button>
    </form>
</template>


<script>
    import axios from '@/configs/Axios'

    export default {
        name: 'form-change-visor',
        props:{
            Edvisor:{
                type:Object,
            },
            studyPlan:{
                type:Object,
            }
        },
        data() {
            return {
                VisorData: null,
                edvisors: [],
                loading: false,
                description: '',
            }
        },
        computed: {
            emptyMessage() {
                // Если нет активного студ плана, показываем сообщение
                if (!this.VisorData) return true
            },
            user() {
                return this.$store.state.user.user
            },

        },

        methods: {
            gdgdg(){
                // console.log(this.VisorData)
            },
            multiselectRemove() {
                // Очищаем данные со студ планом и списком пользователей
                this.VisorData = null
            },
            multiselectAction(item) {
                // Выбираем студ план и запрашиваем список пользователей
                this.VisorData = item
            },
            async fetchStudyPlan() {
                // Запрашиваем студ план
                try {
                    this.$vs.loading({
                        scale: 0.45
                    })
                    this.loading = true
                    const {
                        data
                    } = await axios.get(`/organizations/advisor_list/`)
                    this.edvisors = data
                } catch (e) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                } finally {
                    this.loading = false
                    this.$vs.loading.close()
                }
            },

            async formSubmit() {
                this.$validator.validateAll().then(async result => {
                    await axios.post(`/organizations/request_advisor/`, {
                                                                            "student":this.user.profileId,
                                                                            "cause": this.description,
                                                                            "new_advisor":this.VisorData.uid,
                                                                            "old_advisor":this.Edvisor.profileId,
                                                                            "study_plan":this.studyPlan.uid,
                                                                        }
                    ).then((res)=>{
                        this.description = '';
                        this.VisorData = null;
                        if(res.data.message){
                            this.$vs.notify({
                                text: res.data.message,
                                color: 'danger'
                            })
                        }else{
                            this.$vs.notify({
                                text: this.$t('your_application_successfully_send'),
                                color: 'success'
                            })
                        }
                        this.$emit('close');

                    }).catch(err=>{
                        //ждем HAVE_ACTIVE_REQUESTS
                        this.$vs.notify({
                            text: this.$t(err.error),
                            color: 'danger'
                        });
                        //если 400 то кнопка эдвайзера 'смена эдвайзера' будет disabled
                        this.Edvisor.is_mod_can_edit = true
                    })

                });

            }
        }

    }

</script>
